import React, { useEffect, useState } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import Footer from "../../structures/Footer";
import "../../../assets/css/booking-success.css";

export default function FailedPage() {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const bookingId = searchParams.get("bookingId");

  const [bookingData] = useState(() => {
    const saved = localStorage.getItem("bookingData");
    return saved ? JSON.parse(saved) : null;
  });

  const isMantosExperience = bookingData?.experience?.id?.startsWith('mantos-');

  useEffect(() => {
    const timeoutId = setTimeout(() => {
      const elements = document.querySelectorAll(".animate-on-scroll");
      const observer = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            if (entry.isIntersecting) {
              entry.target.classList.add("animate");
            }
          });
        },
        { threshold: 0.1 }
      );
      elements.forEach((el) => observer.observe(el));
    }, 100);
    return () => clearTimeout(timeoutId);
  }, []);

  return (
    <div className="success-page-container">
      <section className="success-header animate-on-scroll">
        <div className="success-icon-wrapper">
          <div className="success-icon failed">✕</div>
          <div className="success-ring failed"></div>
        </div>
        <h1 className="success-title">Booking Failed</h1>
        <p className="success-subtitle">
          Your booking session has expired or the payment was unsuccessful
        </p>
        <div className="success-ornament">◆ ◆ ◆</div>
      </section>

      <section className="success-content animate-on-scroll">
        <div className="success-content-wrapper">
          <div className="confirmation-card failed">
            <div className="card-header">
              <h2>Session Information</h2>
              {bookingId && (
                <div className="booking-id">
                  <span className="id-label">Booking ID</span>
                  <span className="id-value">{bookingId}</span>
                </div>
              )}
            </div>

            <div className="info-section">
              <p className="failed-message">
                To ensure availability for all guests, booking sessions are limited to 1 hour.
                Unfortunately, your session has timed out or there was an issue with the payment gateway.
              </p>
              <div className="failed-guidelines">
                <h4>What can I do?</h4>
                <ul>
                  <li>Check if your balance was deducted</li>
                  <li>Try booking again for the same or different slot</li>
                  <li>Contact our support if you have already been charged</li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="success-actions animate-on-scroll">
        <button className="action-btn primary" onClick={() => navigate(isMantosExperience ? "/mantos" : "/reservation")}>
          <span>Try Again</span><span className="btn-icon">🔄</span>
        </button>
        <button className="action-btn secondary" onClick={() => navigate("/")}>
          <span>Back to Home</span><span className="btn-icon">🏠</span>
        </button>
      </section>
      <Footer />
    </div>
  );
}


//end